import { GridRowMutationAction, GridRowMutationResponse } from './mutate-grid-resource-row.model';

export enum MutateMasterPaidRowRequestKeys {
  action = 'action',
  rowKey = 'rowKey',
  values = 'values',
}

export interface MutateMasterPaidRowRequest {
  [MutateMasterPaidRowRequestKeys.action]: GridRowMutationAction;
  [MutateMasterPaidRowRequestKeys.rowKey]?: string | number | null;
  [MutateMasterPaidRowRequestKeys.values]?: Record<string, unknown> | null;
}

export type MutateMasterPaidRowResponse = GridRowMutationResponse;
